export default {
	isMobile(val) {
		const reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
		return reg.test(val)
	},
	isIdCard(val) {
		const reg = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
		return reg.test(val)
	},
	// 检测数字
	checkStrExistNumber: () => /\d+(.\d+)?/g
}
